import { useEffect, useState } from "react"
import { Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { connect } from "react-redux"
import { labels } from "../../constants/labels"
import * as loaderActions from "../../redux/loader/actions"
import { useHistory } from "react-router-dom"
import { clearIndexDB } from "../../constants/utils"
import img from "../../assets/images/error_img.png"

const Page = styled("div")({
    width: "100%",
    height: "100%",
    backgroundColor: "#FFF",
    position: "fixed",
    marginTop: "0.125em",
    backgroundImage: `url(${img})`,
    backgroundRepeat: "no-repeat, no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize: "50% 50%",
})

const Container = styled(Grid)({
    height: "100%",
    justifyContent: "center",
})

const ErrorType = styled(Typography)({
    fontWeight: "bolder",
    padding: "0.5em 0",
})
const goBack = (history) => {
    history.push("/")
}
const ErrorPage = ({ Error, hideLoader, selectedShipper }) => {
    let history = useHistory()
    const [skipCount, setSkipCount] = useState(true)

    useEffect(() => {
        hideLoader()
    })

    let selected_shipper_orgname = selectedShipper
        ? selectedShipper.orgName
        : ""
    let selected_shipper_grantor_orgname = selectedShipper
        ? selectedShipper.grantors
            ? selectedShipper.grantors[0]["orgName"]
            : ""
        : ""

    useEffect(() => {
        if (skipCount) setSkipCount(false)
        if (!skipCount) goBack(history)
        clearIndexDB()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected_shipper_orgname, selected_shipper_grantor_orgname])

    return (
        <Page>
            <Container
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs={6}>
                    <Typography variant="span" align="left">
                        Error
                    </Typography>
                    <ErrorType variant="h4" align="left">
                        403
                    </ErrorType>
                    <Typography variant="inherit" align="left">
                        {`${labels.errorPage.description}.`}
                    </Typography>

                    <Typography>{Error}</Typography>
                </Grid>
            </Container>
        </Page>
    )
}

const mapDispatchToProps = {
    hideLoader: loaderActions.hideLoader,
}

const mapStateToProps = (state) => ({
    selectedShipper: state.userProfile.selectedShipper,
})

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage)
